export enum HiikerColor {
  yellow = '#ffc107',
  orange = '#f57700',
  green = '#70c381',
  blue = '#2cc2e3',
  purple = '#C37098',
  red = '#DB2B35',
}
